import { IMAGE_SERVICE_ORIGIN } from '@config/imageService';

/**
 * Site icons come from our own image service, never from the visitor's browser reaching out to
 * the site (or to a third-party icon lookup): the worker looks a host up, stores the icon it finds,
 * and serves it from then on. This only builds that URL, so callers derive it during render with
 * no state, effect or query.
 */

/** Cheap sanity filter, not validation: the worker is the authority on which hosts it will fetch. */
const DOTTED_HOSTNAME = /^[a-z0-9-]+(\.[a-z0-9-]+)+$/;

/**
 * Icon URL for the site an http(s) URL points at. null for anything unparsable, non-http(s), or
 * without a dotted hostname. `www.` is kept: the worker's fallback must fetch the host the link
 * really points at, and every surface showing the same link must ask about the same host.
 */
export const getFaviconUrl = (url: string): string | null => {
  try {
    const { protocol, hostname } = new URL(url);
    if (protocol !== 'http:' && protocol !== 'https:') return null;
    return DOTTED_HOSTNAME.test(hostname) ? `${IMAGE_SERVICE_ORIGIN}/favicon/${hostname}` : null;
  } catch {
    return null;
  }
};
